export default __webpack_public_path__ + "static/media/grafema_nutrana_04.36142e2a.jpg";